import { observer } from 'mobx-react-lite';
import { ReactNode, useEffect, useState } from 'react';
import '../../css/headermenu.css';
import menuStore from '../../store/MenuStore'; // store import
import BaseLayout from './BaseLayout';
import HeaderMenu from './HeaderMenu';

interface BBDesktopProps {
  children: ReactNode;
}

const BBDesktop: React.FC<BBDesktopProps> = observer(({ children }) => {
  const [hasEntered, setHasEntered] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setHasEntered(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const headerClass =
    !hasEntered
      ? 'header-menu enter'
      : menuStore.isVisible
      ? 'header-menu'
      : 'header-menu hide';

  return (
    <BaseLayout>
      <div className={headerClass} style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: '10'
      }}>
        { menuStore.isAttacted ? <HeaderMenu /> : <></> }
      </div>
      <div style={{ paddingTop: '0px' }}>{children}</div>
    </BaseLayout>
  );
});

export default BBDesktop;
